import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';
import { LessonFamilyService } from './lesson-family.service';


@NgModule({
    imports: [
        JYoguiSharedModule
    ],
    declarations: [
    ],
    entryComponents: [
    ],
    providers: [
        LessonFamilyService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiLessonFamilyModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson-family/lesson-family.module.ts